import * as ActionType from '../../constants/actionType';

const initialState = {};

export default function temporaryStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.ADD_TEMPORARY_STATE:
      return {...state, [action.name]: action.state};
    case ActionType.REMOVE_TEMPORARY_STATE:
      return {...state, [action.name]: null};
    case ActionType.RESET_TEMPORARY_STATE:
      return initialState;
    case ActionType.RESTORE_TEMPORARY_STATE:
      return action.state;
    default:
      return state;
  }
}
